/* ========================================================
   H.OLA - SOSYAL MEDYA LİNKLERİ YENİ SEKME (KESİN ÇÖZÜM)
======================================================== */
function setSocialLinksTarget(event) {
  var socialLink = event.target.closest('.footer__block-social-icons a');
  if (socialLink) {
    socialLink.setAttribute('target', '_blank');
    socialLink.setAttribute('rel', 'noopener noreferrer');
  }
}

// Mouse ile üzerine gelindiğinde anında uygula (Masaüstü)
document.addEventListener('mouseover', setSocialLinksTarget);

// Parmağıyla dokunmaya başladığı an uygula (Mobil)
document.addEventListener('touchstart', setSocialLinksTarget, {passive: true});
/* =========================================================================
   H.OLA - Saydam header kontrasti
   Header'in tam arkasina denk gelen gorsel seridini olcer, koyuysa
   <html>'e .hola-hdr--dark, aciksa .hola-hdr--light basar.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = {
    // Olculen parlaklik bu degerin ALTINDAysa gorsel "koyu" sayilir -> beyaz header.
    // 0.54 = mevcut 4 slaytin olculen degerlerinin tam ortasi.
    threshold: 0.54,
    probeWidth: 160,
    // Elle zorlama: { 'theme-block-banner_r8hiXT': 'dark' }
    force: {},
    debug: false
  };

  var GROUP = '.fixed-header-group';
  var OVERLAY = '.popup-modal, modal-dialog, cart-drawer, current-sales-popup, .promotion-popup, .age-verification-popup';
  var cache = new Map();
  var current = null, token = 0, timer = null;

  function log() {
    if (CFG.debug && window.console) console.log.apply(console, ['[hola-hdr]'].concat([].slice.call(arguments)));
  }

  function headerRow(group) {
    var rows = group.querySelectorAll('.header__main, .header__mobile');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i].getBoundingClientRect();
      if (r.height > 4 && r.width > 4) return r;
    }
    return null;
  }

  function visibleImage(root, hRect) {
    var nodes = root.querySelectorAll('img');
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.width > 8 && r.height > 8 &&
          r.right > 0 && r.left < window.innerWidth &&
          r.top < hRect.bottom && r.bottom > hRect.top) return nodes[i];
    }
    return null;
  }

  function usable(el) { return el && !el.closest(GROUP) && !el.closest(OVERLAY); }

  function backdrop(hRect) {
    var i, img, list;
    list = document.querySelectorAll('.swiper-slide-active');
    for (i = 0; i < list.length; i++) {
      if (!usable(list[i])) continue;
      img = visibleImage(list[i], hRect);
      if (img) return { img: img, host: list[i] };
    }
    list = document.querySelectorAll('.shopify-section, section');
    for (i = 0; i < list.length; i++) {
      if (!usable(list[i])) continue;
      img = visibleImage(list[i], hRect);
      if (img) return { img: img, host: list[i] };
    }
    return null;
  }

  function parsePos(v, free) {
    if (v == null) return free * 0.5;
    if (v === 'left' || v === 'top') return 0;
    if (v === 'right' || v === 'bottom') return free;
    if (v === 'center') return free * 0.5;
    if (v.indexOf('%') > -1) return free * (parseFloat(v) / 100);
    var n = parseFloat(v);
    return isNaN(n) ? free * 0.5 : n;
  }

  function clamp01(n) { return n < 0 ? 0 : (n > 1 ? 1 : n); }

  function bandOf(img, hRect) {
    var box = img.getBoundingClientRect();
    if (box.width < 1 || box.height < 1) return null;
    var top = Math.max(box.top, hRect.top);
    var bottom = Math.min(box.bottom, hRect.bottom);
    if (bottom - top < 1) return null;
    var natW = img.naturalWidth, natH = img.naturalHeight;
    if (!natW || !natH) return null;

    var cs = window.getComputedStyle(img);
    var fit = cs.objectFit || 'fill';
    var scale = null;
    if (fit === 'cover') scale = Math.max(box.width / natW, box.height / natH);
    else if (fit === 'contain' || fit === 'scale-down') scale = Math.min(box.width / natW, box.height / natH);
    if (!scale) return { x: 0, y: 0, w: 1, h: 1 };

    var free = (cs.objectPosition || '50% 50%').trim().split(/\s+/);
    var offX = parsePos(free[0], box.width - natW * scale);
    var offY = parsePos(free.length > 1 ? free[1] : free[0], box.height - natH * scale);

    var sx = (0 - offX) / scale;
    var sy = ((top - box.top) - offY) / scale;
    var sw = box.width / scale;
    var sh = (bottom - top) / scale;

    var fx = clamp01(sx / natW), fy = clamp01(sy / natH);
    var fw = clamp01(sw / natW), fh = clamp01(sh / natH);
    if (fx + fw > 1) fw = 1 - fx;
    if (fy + fh > 1) fh = 1 - fy;
    if (fw <= 0 || fh <= 0) return null;
    return { x: fx, y: fy, w: fw, h: fh };
  }

  function probeUrl(src, w) {
    try {
      var u = new URL(src, location.href);
      if (u.pathname.indexOf('/cdn/shop') > -1 || u.hostname.indexOf('cdn.shopify.com') > -1) {
        u.searchParams.set('width', String(w));
      }
      return u.href;
    } catch (e) { return src; }
  }

  function statsOf(data) {
    var sum = 0, dark = 0, light = 0, n = 0;
    for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 8) continue;
      var l = (0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2]) / 255;
      sum += l; n++;
      if (l < 0.35) dark++; else if (l > 0.7) light++;
    }
    if (!n) return null;
    return { mean: sum / n, dark: dark / n, light: light / n };
  }

  function measure(src, band) {
    var key = src + '|' + [band.x, band.y, band.w, band.h].map(function (v) { return v.toFixed(3); }).join(',');
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    return new Promise(function (resolve) {
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.decoding = 'async';
      probe.onload = function () {
        var s = null;
        try {
          var nw = probe.naturalWidth, nh = probe.naturalHeight;
          var sx = Math.max(0, Math.min(nw - 1, Math.round(band.x * nw)));
          var sy = Math.max(0, Math.min(nh - 1, Math.round(band.y * nh)));
          var sw = Math.max(1, Math.min(nw - sx, Math.round(band.w * nw)));
          var sh = Math.max(1, Math.min(nh - sy, Math.round(band.h * nh)));
          var cw = Math.min(64, sw), ch = Math.min(16, sh);
          var cnv = document.createElement('canvas');
          cnv.width = cw; cnv.height = ch;
          var ctx = cnv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(probe, sx, sy, sw, sh, 0, 0, cw, ch);
          s = statsOf(ctx.getImageData(0, 0, cw, ch).data);
        } catch (e) { s = null; }
        cache.set(key, s);
        resolve(s);
      };
      probe.onerror = function () { cache.set(key, null); resolve(null); };
      probe.src = probeUrl(src, CFG.probeWidth);
    });
  }

  function apply(state) {
    if (state === current) return;
    current = state;
    var root = document.documentElement;
    root.classList.toggle('hola-hdr--dark', state === 'dark');
    root.classList.toggle('hola-hdr--light', state !== 'dark');
    log('durum ->', state);
  }

  function run() {
    var group = document.querySelector(GROUP);
    if (!group) return;
    var hRect = headerRow(group);
    if (!hRect) return;

    var found = backdrop(hRect);
    if (!found) { apply('light'); return; }

    var block = found.host.querySelector ? found.host.querySelector('[id^="theme-block-"]') : null;
    if (block && CFG.force[block.id]) { apply(CFG.force[block.id]); return; }

    if (!found.img.complete || !found.img.naturalWidth) {
      found.img.addEventListener('load', schedule, { once: true });
      return;
    }

    var band = bandOf(found.img, hRect);
    if (!band) { apply('light'); return; }

    var mine = ++token;
    var src = found.img.currentSrc || found.img.src;
    measure(src, band).then(function (s) {
      if (mine !== token) return;
      window.holaHeaderContrast.last = { src: src, block: block ? block.id : null, stats: s };
      log(src, s);
      apply(s && s.mean < CFG.threshold ? 'dark' : 'light');
    });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(run, 60); }

  function boot() {
    schedule();
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    if ('MutationObserver' in window) {
      var slider = document.querySelector('.section-slider .swiper-wrapper') ||
                   document.querySelector('.swiper-wrapper');
      if (slider) {
        new MutationObserver(schedule).observe(slider, {
          attributes: true, attributeFilter: ['class'], subtree: true
        });
      }
    }
  }

  window.holaHeaderContrast = {
    config: CFG,
    refresh: schedule,
    inspect: function () {
      var group = document.querySelector(GROUP);
      if (!group) return { hata: 'fixed-header-group yok' };
      var hRect = headerRow(group);
      if (!hRect) return { hata: 'gorunen header satiri yok' };
      var f = backdrop(hRect);
      if (!f) return { hata: 'header arkasinda gorsel bulunamadi', durum: current };
      return {
        header: [Math.round(hRect.top), Math.round(hRect.bottom)],
        host: f.host.id || f.host.className,
        img: (f.img.currentSrc || f.img.src).split('/').pop(),
        yuklendi: f.img.complete && !!f.img.naturalWidth,
        band: bandOf(f.img, hRect),
        durum: current
      };
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* =========================================================================
   H.OLA — EasyGift (EG Auto Add to Cart) popup buton metni Türkçeleştirme
   -------------------------------------------------------------------------
   Uygulamanın hediye seçim penceresi `#aca-modal`, ürün butonları
   `.aca-product-button`. Uygulama betiği (cdn.506.io/eg/script.js) buton
   yazısını `C = "Select"` ile varsayılan İngilizce basıyor ve ancak
   `settings.popupStyle.addButtonText` doluysa onu kullanıyor — mağazada o
   ayar boş.

   KALICI ÇÖZÜM uygulamanın kendi ayarıdır:
     EasyGift admin > Settings > Popup > "Add button text" = Seçin
   Aşağıdaki kod o ayar doldurulana kadar geçerli olan tema tarafı yamadır;
   ayar doldurulduğunda buton zaten "Seçin" yazacağı için bu kod hiçbir şey
   yapmaz (çakışma olmaz).
   ========================================================================= */
(function () {
  'use strict';

  // Yalnızca BİREBİR eşleşen İngilizce etiket değiştirilir; kısmi eşleşme yok,
  // böylece ürün adının içinde geçen bir kelime yanlışlıkla ezilmez.
  var SOZLUK = {
    'Select': 'Seçin'
  };

  function cevir() {
    var modal = document.getElementById('aca-modal');
    if (!modal) return;
    var butonlar = modal.querySelectorAll('.aca-product-button');
    for (var i = 0; i < butonlar.length; i++) {
      var b = butonlar[i];
      var yeni = SOZLUK[(b.textContent || '').trim()];
      if (yeni) b.textContent = yeni;
    }
  }

  var bekleyen = false;
  function planla() {
    if (bekleyen) return;
    bekleyen = true;
    // Aynı mutation dalgasında defalarca çalışmasın diye tek kareye toplanır.
    requestAnimationFrame(function () { bekleyen = false; cevir(); });
  }

  function baslat() {
    cevir(); // pencere zaten açıksa
    new MutationObserver(planla).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
